import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {InterventionCategory} from "../models/intervention-category";
import {CacheService} from "@customcoding/shared";

@Injectable({
	providedIn: 'root'
})
export class InterventionCategoryService {
	constructor(private cache: CacheService) {
	}

	public getAll(): Observable<InterventionCategory[]> {
		return this.cache.get("/api/scap/intervention-category");
	}
}
